import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image"
import VideoPlayer from './videoPlayer';

const FeaturedMedia = ({ image, video, color, ratio, title }) => {

  return (
    <div className='featured--media p10'>
      <div className={'pos-rel overflow-hidden bg-dark video-wrapper ' + ratio} style={{ background: color?.hex }}>
        {(video ?
          <div className="bg-image video-wrapper">
            <VideoPlayer url={video} />
          </div>
          :
          <GatsbyImage className='bg-image' image={image} alt={title} />
        )}
      </div>
    </div>
  )
}
export default FeaturedMedia
